import PopupModal from "../../common/PopupModal";
import PopupModalWithCancelButton from "../../common/PopupModalWithCancelButton";
import LoaderPopupModel from "../../common/LoaderPopup";
import { useDispatch } from "react-redux";
import { fetchStaffListAsync } from "../../../store/thunks/staffListThunk";

const StaffListPopups = ({
  updateStatus,
  deleteUserStatus,
  STATUS,
  show,
  approveButtonClicked,
  popUpMsg,
  approveUser,
  closeModal,
  rejectButtonClicked,
  rejectUser,
  showApprovedPopUp,
  errorMsg,
  errorDeleteMsg,
  currentPage,
  rowsPerPageValue,
  keyVal,
  errorMsgStatus,
  StaffListConstants,
  fetchStaffListAsync,
}: any) => {
  const dispatch = useDispatch();

  return (
    <>
      {(updateStatus === STATUS.LOADING || deleteUserStatus === STATUS.LOADING) && (
        <LoaderPopupModel
          isOpen={
            updateStatus === STATUS.LOADING ||
            deleteUserStatus === STATUS.LOADING
          }
        />
      )}
      {show && approveButtonClicked && (
        <PopupModalWithCancelButton
          popUpTitle={StaffListConstants.AreYouSure}
          popUpMsg={popUpMsg}
          isOpen={show}
          onOkay={approveUser}
          onCancel={closeModal}
        />
      )}

      {show && rejectButtonClicked && (
        <PopupModalWithCancelButton
          popUpTitle={StaffListConstants.AreYouSure}
          popUpMsg={popUpMsg}
          isOpen={show}
          onOkay={rejectUser}
          onCancel={closeModal}
        />
      )}

      {showApprovedPopUp && (
        <PopupModal
          popUpTitle={
            errorMsg == null
              ? errorDeleteMsg == null
                ? popUpMsg
                : errorDeleteMsg
              : errorMsg
          }
          popUpMsg={StaffListConstants.UserApprovedDescription}
          buttonText={StaffListConstants.Okay}
          isOpen={showApprovedPopUp}
          onClose={() => {
            closeModal();
            dispatch(
              fetchStaffListAsync({
                pageNumber: currentPage - 1,
                rowsPerPage: rowsPerPageValue,
                key: keyVal,
              })
            );
          }}
          isSucessMessage={
            errorMsg == null && errorDeleteMsg == null
              ? errorMsgStatus
              : false
          }
        />
      )}

     
    </>
  );
};

export default StaffListPopups;